export default {
  address: {
    action: {
      editManual: 'Update manually',
      lookup: 'Lookup address',
      movePin: 'Move pin'
    },
    area: 'Local area',
    area1: 'Local area 1',
    area2: 'Local area 2',
    city: 'City',
    country: 'Country',
    editTitle: 'Edit address',
    latitude: 'Latitude',
    longitude: 'Longitude',
    lookupPlaceholder: 'Enter an address to look up',
    movePinMessage: 'Drag the pin to the desired location. This does not affect the address details, only the location.',
    notSet: 'No address information available',
    postalCode: 'Postal code',
    street: 'Street',
    streetNumber: 'Street number'
  },
  admin: {
    companies: {
      matching: 'Matching companies',
      title: 'Companies'
    },
    company: {
      accountsTitle: 'Applications',
      action: {
        merge: 'Merge other company users'
      },
      createTitle: 'Create company',
      editTitle: 'Edit company',
      mergeMessage: 'Select the company that should be merged with {name}. All users will be moved and the other company will be deleted.',
      mergeTitle: 'Move all users from another company',
      referencesTitle: 'References',
      title: 'Company details',
      userPermissionsTitle: 'User permissions'
    },
    general: {
      title: 'General'
    },
    title: 'Administration',
    user: {
      action: {
        activate: 'Activate user',
        createApiKey: 'Create API key',
        inactivate: 'Inactivate user',
        resetPassword: 'Reset password',
        updateCompany: 'Update company',
        updateRole: 'Update role'
      },
      confirmActivate: 'Are you sure you want to activate the user?',
      confirmInactivate: 'The user will not be able to log in or use API-keys when inactivated.',
      createTitle: 'Create user',
      credentials: {
        createPassword: 'Allow login',
        createdOn: 'Created on',
        empty: 'No credentials found',
        resetRequestedOn: 'Reset requested on',
        title: 'Credentials'
      },
      editTitle: 'Edit user details',
      title: 'User details'
    },
    users: {
      matching: 'Matching users',
      title: 'Users'
    }
  },
  application: {
    bynder: 'Bynder',
    eCommerce: 'E-commerce',
    reco: 'Product Recommendation'
  },
  applicationAccess: {
    application: 'Application',
    authorization: 'Authorization credentials',
    brand: 'Brand',
    confirmDisable: 'Are you sure you want to disable access to this application?',
    confirmEnable: 'Are you sure you want to enable access to this application?',
    disabled: 'Disabled',
    enabled: 'Enabled',
    owner: 'Owner'
  },
  brand: {
    champion: 'Champion',
    wolf: 'Wolf'
  },
  company: {
    action: {
      select: 'Select company'
    },
    address: 'Address',
    brand: 'Primary brand',
    email: 'Email',
    filterCustomer: 'Show customers only',
    name: 'Name',
    owner: 'Owner',
    phoneNumber: 'Phone number',
    customer: 'Customer',
    accountNumber: 'Customer account number',
    users: 'Users in company',
    website: 'Website'
  },
  companyRelation: {
    related: 'Related',
    subject: 'Subject',
    type: 'Type'
  },
  companyUserPermission: {
    confirmDelete: 'Are you sure you want to revoke this permission?',
    create: 'Add permission',
    permission: 'Permission',
    title: 'User permissions in company',
    user: 'User'
  },
  error: {
    general: 'An error occured'
  },
  form: {
    email: {
      label: 'Email address',
      placeholder: 'Enter an email address'
    },
    password: {
      label: 'Password',
      placeholder: 'Enter a password',
      message: 'Your password should be at least 8 characters long and contain one lowercase letter, uppercase letter, number, and a special character.'
    }
  },
  general: {
    accountHelpMessage: 'Experiencing trouble signing in?',
    accountSummary: 'You are signed in using {email}.',
    action: {
      add: 'Add',
      cancel: 'Cancel',
      confirm: 'Confirm',
      delete: 'Delete',
      disable: 'Disable',
      edit: 'Edit',
      enable: 'Enable',
      lookup: 'Lookup',
      ok: 'Got it',
      returnToDashboard: 'Return to dashboard',
      revoke: 'Revoke',
      save: 'Save',
      search: 'Search',
      select: 'Select',
      showDetails: 'Details',
      signOut: 'Sign out'
    },
    actions: 'Actions',
    address: 'Address',
    any: 'Any',
    appOnlyMessage: 'A browser version of the customer portal will be available soon. In the mean time, download one of our apps to get started!',
    championTitle: 'Co-Pilot',
    confirmTitle: 'Confirmation',
    contactUs: 'Contact our Help Center',
    createdOn: 'Created on',
    emptyState: 'No matching data available',
    enterSearchText: 'Enter text to start searching',
    info: 'General information',
    informationTitle: 'Information',
    localName: 'Local name',
    moreResults: 'and {count} more results...',
    navigation: 'Navigation',
    no: 'No',
    noResult: 'No matching result found',
    notSet: 'Not set',
    permissionDenied: {
      action: {
        return: 'Return to dashboard'
      },
      message: 'You don\'t have the correct permissions to access this page.',
      title: 'Permission denied'
    },
    searchText: 'Search text',
    searchTextPlaceholder: 'Enter text to search',
    selectPlaceholder: 'Select an option',
    status: 'Status',
    wolfTitle: 'I-Monitor',
    yes: 'Yes'
  },
  module: {
    bynder: {
      info: 'Your account is not associated with a Bynder account yet. To get access to the marketing portal, please {contact}.'
    },
    eCommerce: {
      title: 'E-commerce'
    }
  },
  oauth: {
    error: {
      credentials: 'The email or password you entered is incorrect',
      invalid: 'Your sign in attempt has expired or is invalid.'
    },
    message: 'Enter your username and password below to use your {appName} account to sing in to {clientName}.',
    return: 'Return to {clientName}'
  },
  reco: {
    browse: {
      brand: 'Brand',
      category: 'Category',
      model: 'Model',
      title: 'Browse'
    },
    license: {
      input: 'License plate - {country}',
      title: 'By licence plate'
    },
    noResults: 'Your search did not result in any results',
    noSearch: 'Enter a search term to view results',
    recommendation: {
      brand: 'Brand',
      info: 'Vehicle details',
      model: 'Model'
    },
    search: {
      input: 'Search text',
      title: 'By text'
    },
    title: 'Find your product',
    vin: {
      input: 'Vehicle Identification Number (VIN)',
      title: 'By VIN number'
    }
  },
  report: {
    performance: {
      actual: 'Actual',
      budget: 'Budget',
      categoryTitle: '{type} per category',
      delta: 'Bud vs. actual',
      forecast: 'Forecast',
      noData: 'There is currenlty no performance data available',
      volume: 'Volume',
      turnover: 'Turnover',
      category: 'Category'
    },
    title: 'Reports & Insights'
  },
  reportPerformance: {
    title: 'Performance'
  },
  resetPassword: {
    action: {
      request: 'Request reset',
      update: 'Update password'
    },
    error: {
      expired: 'The password reset link is incorrect, has already been used or is expired.',
      invalid: 'No active user account is found for this email address.'
    },
    message: 'Forgot your password? Don\'t worry, just enter your email address and we will send you instructions to reset your password.',
    requested: 'You will receive an email with a link that allows you te reset your password.',
    title: 'Reset password',
    update: '{display_name}, please enter the password you want to use to access your account, using {email}.'
  },
  salespoint: {
    brands: 'Brands',
    channel: 'Channel',
    confirmDelete: 'Are you sure you want to delete this sales point? It will be permanently removed from the system.',
    externalId: 'External ID',
    externalIdInfo: 'A unique identifier for the sales point in an external system',
    flags: 'Sales point info',
    garageConcept: 'Garage concept',
    nameInfo: 'Start the name of the sales point with a capital letter',
    published: 'Publish on website',
    segments: 'Segments',
    title: 'Sales point details'
  },
  salespointCreate: {
    title: 'Add sales point'
  },
  salespointEdit: {
    title: 'Edit sales point'
  },
  salespointList: {
    matching: 'Matching sales points',
    title: 'Manage sales points'
  },
  salespointMap: {
    allMatches: 'No matches found | Showing one match | Showing {count} matches',
    firstMatches: 'Showing first {count} matches of {totalCount}',
    overflow: 'Refine the search to ensure all matches are shown',
    searchTitle: 'Find sales points',
    title: 'Map'
  },
  salespoints: {
    title: 'Sales points'
  },
  signin: {
    action: {
      confirm: 'Sign in'
    },
    error: {
      credentials: 'The email or password you entered is incorrect'
    },
    forgotPassword: 'Can\'t remember?',
    pageTitle: 'Sign in',
    signedOut: 'You have been signed out',
    tagLine: 'Wolf Oil Corporation',
    title: 'Sign in to {appName}'
  },
  user: {
    company: 'Company',
    createdOn: 'User since',
    displayName: 'Name',
    email: 'Email',
    firstName: 'First name',
    language: 'Language',
    lastName: 'Last name',
    locale: 'Locale',
    localeMessage: 'An IETF language tag, for example \'en-GB\'',
    role: 'Role',
    statuses: {
      active: 'Active',
      inactive: 'Inactive',
      unverified: 'Unverified'
    }
  },
  userAccount: {
    contact: {
      phoneNumber: 'Phone number',
      title: 'Contact details'
    },
    title: 'Your account'
  }
}
